import jsonExport from "jsonexport/dist";
import { downloadCSV, type Exporter } from "ra-core";

import { formatDate } from "../misc/formatDate";
import type { Company } from "../types";

export const COMPANIES_EXPORT_COLUMNS = [
  "bedrijfsnaam",
  "adres",
  "email_factuurontvanger",
  "opmerkingen",
  "contactpersonen",
  "sponsoringen",
  "aangemaakt_op",
] as const;

export type ExportedCompany = Record<
  (typeof COMPANIES_EXPORT_COLUMNS)[number],
  string | number | undefined
>;

/** Flatten companies into CSV rows with Dutch column names. */
export const toExportRows = (records: Company[]): ExportedCompany[] =>
  records.map((company) => ({
    bedrijfsnaam: company.name,
    adres: company.address ?? "",
    email_factuurontvanger: company.invoice_email ?? "",
    opmerkingen: company.description ?? "",
    contactpersonen: company.nb_contacts ?? 0,
    sponsoringen: company.nb_sponsorings ?? 0,
    aangemaakt_op: formatDate(company.created_at),
  }));

export const companyExporter: Exporter<Company> = async (records) =>
  jsonExport(
    toExportRows(records),
    { headers: [...COMPANIES_EXPORT_COLUMNS] },
    (_err: unknown, csv: string) => {
      downloadCSV(csv, "bedrijven");
    },
  );
